import { render, staticRenderFns } from "./notification-ActivityCommented.vue?vue&type=template&id=084fbf9d&scoped=true"
import script from "./notification-ActivityCommented.vue?vue&type=script&lang=js"
export * from "./notification-ActivityCommented.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084fbf9d",
  null
  
)

export default component.exports